import React, { useContext, ReactNode } from 'react';
import { AuthService } from '@vis-auth/vis-auth';

const AuthServiceContext = React.createContext<AuthService | null>(null);

export const useAuthService = (): AuthService => {
  const authService = useContext(AuthServiceContext);
  if (!authService) {
    throw new Error('useAuthService must be used within <Security> or <AuthServiceProvider>');
  }
  return authService;
};

export function AuthServiceConsumer({ children }: { children: (authService: AuthService) => React.ReactNode }) {
  return (
    <AuthServiceContext.Consumer>
      {(authService): ReactNode => {
        if (!authService) {
          throw new Error('AuthServiceConsumer must be used within <Security> or <AuthServiceProvider>');
        }
        return children(authService);
      }}
    </AuthServiceContext.Consumer>
  );
}

export const AuthServiceProvider = AuthServiceContext.Provider;
